module.exports = __webpack_public_path__ + "img/img_avatar3.a5e81f19.png";